"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _global = require("../service/global");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initState = {
  className: '',
  // 附加样式
  pcMainTitle: '',
  // 应用名称
  mobileMainTitle: '',
  // 应用名称
  pcMinTitle: '',
  // 应用的介绍
  mobileMinTitle: '',
  // 应用的介绍
  pcButtonTitle: '',
  mobileButtonTitle: '',
  pcVersionNum: 0,
  mobileVersionNum: 0,
  pcBGImg: '',
  mobileBGImg: '',
  childList: []
};
var _default = {
  namespace: 'global',
  state: initState,
  effects: {
    fetchModalMainDetail:
    /*#__PURE__*/
    regeneratorRuntime.mark(function fetchModalMainDetail(_ref, _ref2) {
      var params, callback, call, put, response, _ref3, pcMainTitle, mobileMainTitle, pcMinTitle, mobileMinTitle, pcButtonTitle, mobileButtonTitle, pcVersionNum, mobileVersionNum, mobileBGImg, pcBGImg;

      return regeneratorRuntime.wrap(function fetchModalMainDetail$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = _ref.params, callback = _ref.callback;
              call = _ref2.call, put = _ref2.put;
              _context.next = 4;
              return call(_global.modalMainDetail, params);

            case 4:
              response = _context.sent;
              _ref3 = response && response[0] || {}, pcMainTitle = _ref3.pcMainTitle, mobileMainTitle = _ref3.mobileMainTitle, pcMinTitle = _ref3.pcMinTitle, mobileMinTitle = _ref3.mobileMinTitle, pcButtonTitle = _ref3.pcButtonTitle, mobileButtonTitle = _ref3.mobileButtonTitle, pcVersionNum = _ref3.pcVersionNum, mobileVersionNum = _ref3.mobileVersionNum, mobileBGImg = _ref3.mobileBGImg, pcBGImg = _ref3.pcBGImg;
              _context.next = 8;
              return put({
                type: 'saveState',
                payload: {
                  pcMainTitle: pcMainTitle,
                  mobileMainTitle: mobileMainTitle,
                  pcMinTitle: pcMinTitle,
                  mobileMinTitle: mobileMinTitle,
                  pcButtonTitle: pcButtonTitle,
                  mobileButtonTitle: mobileButtonTitle,
                  pcVersionNum: pcVersionNum,
                  mobileVersionNum: mobileVersionNum,
                  mobileBGImg: mobileBGImg,
                  pcBGImg: pcBGImg
                }
              });

            case 8:
              if (callback) {
                callback();
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, fetchModalMainDetail, this);
    }),
    fetchModalChildDetail:
    /*#__PURE__*/
    regeneratorRuntime.mark(function fetchModalChildDetail(_ref4, _ref5) {
      var params, callback, call, put, response;
      return regeneratorRuntime.wrap(function fetchModalChildDetail$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = _ref4.params, callback = _ref4.callback;
              call = _ref5.call, put = _ref5.put;
              _context2.next = 4;
              return call(_global.modalChildDetail, params);

            case 4:
              response = _context2.sent;
              _context2.next = 7;
              return put({
                type: 'saveState',
                payload: {
                  childList: response
                }
              });

            case 7:
              if (callback) {
                callback();
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, fetchModalChildDetail, this);
    })
  },
  reducers: {
    resetState: function resetState() {
      return initState;
    },
    saveState: function saveState(state, _ref6) {
      var payload = _ref6.payload;
      return _objectSpread({}, state, payload);
    }
  }
};
exports.default = _default;